export default __webpack_public_path__ + "static/media/slide2-blur.a85cfe25.jpg";